import { createSlice } from "@reduxjs/toolkit";
import { getContactDetailsAPI } from "../../api/contact";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getContactDetailsSlice = createSlice({
  name: "getContactDetails",
  initialState: data,
  reducers: {
   getContactDetailsSlice(state) {
      state.isLoading = true;
    },
   getContactDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getContactDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getContactDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getContactDetailsHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getContactDetailsAction.getContactDetailsSlice());
    const response: any = await getContactDetailsAPI(id);
    
    dispatch(getContactDetailsAction.getContactDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getContactDetailsAction.getContactDetailsSliceFailure(e?.response?.data));
  }
};
export default getContactDetailsSlice.reducer;
export const getContactDetailsAction = getContactDetailsSlice.actions;
